import { React, useState } from 'react'
import {
  Box,
  Badge,
  IconButton,
  Flex,
  Text,
  VStack,
  Image,
  Tag,
} from '@chakra-ui/react'
import {
  AiOutlineUserAdd,
  AiOutlineUserDelete,
  AiOutlineUsergroupAdd,
} from 'react-icons/ai'
import {
  getCurrentDateUTC,
  getFromNowWithTime,
} from '../../../../utils/date.utils'
import { loadAwsFile } from '../../../../utils/aws.util'
import {
  dataLayerTagManager,
  sectionDetailedTrack,
} from '../../../../containers/repository/repo.utils'
import { GA_CATEGORY_NAVBAR } from './../../../../containers/repository/repo.utils'
import profile from '../../../../assets/images/profile.png'
import group from '../../../../assets/images/group_icon.png'
import { usePubNub } from 'pubnub-react'
import { assign } from 'lodash'
const SingleChatCard = ({
  isGroupChat,
  index,
  returnUserName,
  item,
  onChatListClick,
  addPersonToGroup,
  isSelected,
  removePersonToGroup,
  currUser,
  org,
}) => {
  const {
    contact_phone_country_code,
    contact_phone_number,
    contact_department,
    group_icon,
  } = JSON.parse(item.activity_inline_data)

  const [onlineStatus, setOnlineStatus] = useState(false)
  const pubnub = usePubNub()
  if (group_icon)
    loadAwsFile(group_icon, d => {
      item.groupIcon = 'data:' + d.type + ';base64,' + d.data
    })

  if (item?.activity_lead_asset_image_path) {
    loadAwsFile(item?.activity_lead_asset_image_path, d => {
      item.icon = 'data:' + d.type + ';base64,' + d.data
    })
  }

  setTimeout(() => {
    pubnub.whereNow(
      {
        uuid: item.activity_lead_asset_id + '-' + org,
      },
      (status, response) => {
        if (!!response && !!response.channels && response.channels.length > 0) {
          setOnlineStatus(true)
        } else {
          setOnlineStatus(false)
        }
      }
    )
  }, 100)
  const convertUnicode = input => {
    return input.replace(/\\u(\w{4,4})/g, function (a, b) {
      var charcode = parseInt(b, 16)
      return String.fromCharCode(charcode)
    })
  }
  let msg = ''
  let recentMsg = ''

  if (!isGroupChat && item?.last_message !== undefined) {
    msg = JSON.parse(item?.last_message)
    recentMsg = msg?.mail_body
  }
  return (
    <Box
      p="1.5"
      key={index}
      cursor={!isGroupChat ? 'pointer' : ''}
      maxW="100%"
      border="1px solid #F2F2F2"
      bg={currUser === item.activity_id ? '#F1F3F9' : ''}
      onClick={() => {
        sectionDetailedTrack({
          category: GA_CATEGORY_NAVBAR,
          action: 'Chat View',
          label: 'Clicked Chat List',
        })
        onChatListClick(item)
      }}
    >
      <Flex
        alignItems="center"
        position="relative"
        justifyContent="space-between"
      >
        <Box>
          <Flex alignItems="center" justifyContent="space-between">
            {item.activity_type_category_id === 27 ? (
              <Image src={group} h="48px" w="48px" borderRadius="50%" />
            ) : (
              <>
                <Box position="relative">
                  <Image
                    src={
                      item?.activity_lead_asset_image_path ? item.icon : profile
                    }
                    h="48px"
                    w="48px"
                    borderRadius="50%"
                  />
                  {onlineStatus ? (
                    <Box
                      sx={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: 'brand.700',
                        border: '2px solid #FFFFFF',
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                      }}
                    ></Box>
                  ) : (
                    ''
                  )}
                </Box>
              </>
            )}
            <VStack
              marginTop={isGroupChat && !isSelected ? '-4' : '0'}
              alignItems="flex-start"
              marginLeft="10px"
              lineHeight="15px"
            >
              <Text
                fontSize="16px"
                fontStyle="normal"
                fontWeight={500}
                color="#131D0B"
              >
                {returnUserName(item)}
              </Text>
              {/* {isGroupChat && !isSelected ? (
                <Text fontStyle="normal" fontWeight={500} color="#969696">
                  +{contact_phone_country_code}
                  {contact_phone_number} | {contact_department}{' '}
                </Text>
              ) : (
                ''
              )} */}

              {!isGroupChat && item?.last_message !== undefined && recentMsg ? (
                recentMsg.length <= 18 ? (
                  <Text
                    fontSize="14px"
                    fontStyle="normal"
                    fontWeight={500}
                    color="#969696"
                    dangerouslySetInnerHTML={{
                      __html: convertUnicode(
                        unescape(
                          (typeof item?.last_message === 'string'
                            ? JSON.parse(item?.last_message || '')
                            : item?.last_message
                          ).content
                        )
                      ),
                    }}
                  />
                ) : (
                  <Text
                    fontSize="14px"
                    fontStyle="normal"
                    fontWeight={500}
                    color="#969696"
                    dangerouslySetInnerHTML={{
                      __html:
                        convertUnicode(
                          unescape(
                            (typeof item?.last_message === 'string'
                              ? JSON.parse(item?.last_message || '')
                              : item?.last_message
                            ).content
                          )
                        ).slice(0, 18) + '...',
                    }}
                  />
                )
              ) : (
                ''
              )}
            </VStack>
          </Flex>
        </Box>

        {isGroupChat ? (
          <IconButton
            variant="outline"
            colorScheme="teal"
            aria-label="Call Segun"
            size="sm"
            icon={
              isSelected ? (
                <AiOutlineUserDelete size="25px" />
              ) : (
                <AiOutlineUserAdd size="25px" />
              )
            }
            onClick={() => {
              sectionDetailedTrack({
                category: GA_CATEGORY_NAVBAR,
                action: 'Chat View',
                label: isSelected
                  ? 'Remove Person From Group'
                  : 'Add Person To Group',
              })
              dataLayerTagManager('button_click', {
                viewName: 'Chat',
                buttonName: isSelected ? 'Remove Group User' : 'Add Group User',
              })
              isSelected ? removePersonToGroup(index) : addPersonToGroup(item)
            }}
          />
        ) : (
          <Flex flexDir="column" alignItems="flex-end" fontSize="12px">
            <Text
              color="#8C8E90"
              fontWeight="400"
              fontStyle="normal"
              mt="-20px"
            >
              {getFromNowWithTime(
                item.activity_datetime_last_updated || getCurrentDateUTC()
              )}
            </Text>

            {item.asset_unread_updates_count > 0 && (
              <Box mt={1}>
                {' '}
                <Badge
                  ml="1"
                  fontWeight={500}
                  color="#323232"
                  bg="#FCC917"
                  h="20px"
                  w="21px"
                  borderRadius="10px"
                  paddingTop="2px"
                  textAlign="center"
                >
                  {item.asset_unread_updates_count}
                </Badge>
              </Box>
            )}
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

export default SingleChatCard
